<template>
    <small class="float-right text-danger p-1" v-if="warningZone">Você será desconectado em breve</small>
</template>

<script>
    import Cookies from 'js-cookie';
    export default {
        name: 'AutoLogout',
        data() {
            return {
                events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
                warningTimer: null,
                logoutTimer: null,
                warningZone: null,
                expire_at: null,
                remember: false,
            }
        },
        mounted() {
            this.checkLogout();
            this.events.forEach(function (event) {
                window.addEventListener(event, this.resetTimer);
            }, this);
            this.setTimers();
            window.onbeforeunload = function (e) {
                Cookies.set('expire_at', Date.now())
            };
        },
        destroyed() {
            this.events.forEach(function (event) {
                window.removeEventListener(event, this.resetTimer);
            }, this);
            //  this.resetTimer();
        },
        methods: {
            async checkLogout() {
                let expired = await Cookies.get('expire_at');
                if (expired) {
                    let startTime = new Date(parseInt(expired));
                    let endTime = new Date();
                    let difference = endTime - startTime;
                    let resultInMinutes = Math.round(difference / 60000);
                    if (resultInMinutes > 5) { //passou de 5 minutos, bora deslogar
                        this.logoutUser();
                    } else {
                        //nao valido para logout, deslogar..
                        Cookies.remove('expire_at');
                    }
                }
            },
            setTimers: function () {
                this.warningTimer = setTimeout(this.warningMessage, 14 * 60 * 1000); // 14 minutes - 14 * 60 * 1000
                this.logoutTimer = setTimeout(this.logoutUser, 15 * 60 * 1000); // 15 minutes - 15 * 60 * 1000
                this.warningZone = false;
                Cookies.remove('expire_at');
            },
            warningMessage: function () {
                this.warningZone = true;
            },
            logoutUser: function () {
                if (Cookies.get('remember') == 'true') {
                    return;
                }
                clearTimeout(this.warningTimer);
                clearTimeout(this.logoutTimer);
                this.logout();
                this.$destroy();
            },
            resetTimer: function () {
                clearTimeout(this.warningTimer);
                clearTimeout(this.logoutTimer);
                this.setTimers();
            }
        }
    }
</script>